import { render, staticRenderFns } from "./ZeroWasteCollectionsWarningsResult.vue?vue&type=template&id=6bd12e89&scoped=true&"
import script from "./ZeroWasteCollectionsWarningsResult.vue?vue&type=script&lang=js&"
export * from "./ZeroWasteCollectionsWarningsResult.vue?vue&type=script&lang=js&"
import style0 from "./ZeroWasteCollectionsWarningsResult.vue?vue&type=style&index=0&id=6bd12e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd12e89",
  null
  
)

export default component.exports